import React, { useState } from 'react';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import useForceUpdateTranslation from '@utils/useForceUpdateTranslation';
import Account from './Account';
import Notifications from './Notifications';
import General from './General';
import Security from './Security';
import ContentHeader from '../../components/_commons/ContentHeader';
import '../../../resources/assets/styles/settings.scss';

function SettingsMain() {
    const { t } = useForceUpdateTranslation();
    const [selectedContainer, setSelectedContainer] = useState<string>('account');

    const handleClick = (container: string) => {
        setSelectedContainer(container);
        document.querySelector('.settings-content-container')?.scrollTo(0, 0);
    };

    return (
        <div
            id="wrapper-content"
            className='container-settings wrapper-content'
            style={{
            }}
        >
            <div
                id="content-header"
                className='content-header settings-header-container'>
                <ContentHeader />
            </div>
            <div className="wrapper-settings content-body">
                <div className="content-sidebar settings-sidebar-container">
                    <div style={{ padding: '15px 30px' }}>
                        <Typography
                            variant="h5"
                            style={{
                                marginBottom: '5px',
                                fontWeight: 'bold'
                            }}
                        >
                            {t('settings.sidebar_title')}
                        </Typography>
                        <Typography variant="caption">
                            {t('settings.sidebar_desc')}
                        </Typography>
                    </div>
                    <List className="container-settings-nav-list" component="nav">
                        {/* {['account', 'general', 'security', 'notifications'].map((item) => ( */}
                        {['account', 'general', 'security'].map((item) => (
                            <ListItemButton
                                key={item}
                                className={`settings-item ${selectedContainer === item ? 'selected' : ''}`}
                                onClick={() => handleClick(item)}
                                /*
                                style={{
                                    backgroundColor: selectedContainer === item
                                        ? 'var(--theme-secondary)'
                                        : 'transparent',

                                }}
                                */
                            >
                                <ListItemText
                                    className="settings-item-text"
                                    primary={t(`settings.navi_data.${item}.label`)}
                                />
                            </ListItemButton>
                        ))}
                    </List>
                </div>

                <div className='settings-content-container'>
                    <div className="settings-content-wrapper">
                        <div
                            className='settings-content-header'>
                            <Typography
                                variant="h5"
                                style={{
                                    marginBottom: 10,
                                    fontWeight: 'bold',
                                }}
                            >
                                {t(`settings.navi_data.${selectedContainer}.label`)}
                            </Typography>
                            <Typography
                                variant="body2"
                                style={{
                                    marginBottom: 10,
                                }}
                            >
                                {t(`settings.navi_data.${selectedContainer}.desc`)}
                            </Typography>
                        </div>

                        {selectedContainer === 'account' && <Account />}
                        {selectedContainer === 'general' && <General />}
                        {selectedContainer === 'security' && <Security />}
                        {/* {selectedContainer === 'notifications' && <Notifications />} */}
                    </div>
                </div>

            </div>
        </div>
    );
}

export default SettingsMain;